<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('detailSaleByCustomerReport.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('detailSaleByCustomerReport.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <ts-card>
            <ts-card-wrapper>
              <ts-loading-banner :loading="loading">
                <form>
                  <fieldset>
                    <legend>
                      {{ $t('detailSaleByCustomerReport.criteria') }}
                    </legend>

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="required">{{
                            $t('detailSaleByCustomerReport.dateRange')
                          }}</label>
                          <a-range-picker
                            format="DD-MM-YYYY"
                            :defaultValue="rangeDate"
                            :defaultPickerValue="rangeDate"
                            @change="dateRangeChange"
                            :ranges="{
                              Today: [moment(), moment()],
                              'This Month': [
                                moment().startOf('month'),
                                moment().endOf('month')
                              ]
                            }"
                          >
                            <template slot="renderExtraFooter"></template>
                          </a-range-picker>
                          <div class="validate" v-if="errors.has('date_range')">
                            {{ errors.first('date_range') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{ $t('monthlySaleItem.branchName') }}</label>
                          <a-select
                            v-model="model.branch_id"
                            :options="branches"
                            class="ts-w-full"
                            placeholder="All"
                            showSearch
                            mode="multiple"
                            :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                            @change="getLocations"
                          ></a-select>
                          <div class="validate" v-if="errors.has('branch_id')">
                            {{ errors.first('branch_id') }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{
                            $t('stockTransferReport.warehouse')
                          }}</label>
                          <a-select
                            v-model="model.location_id"
                            :options="locations"
                            showSearch
                            :loading="location_loading"
                            mode="multiple"
                            :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                            placeholder="All"
                            class="ts-w-full"
                          ></a-select>
                          <div
                            class="validate"
                            v-if="errors.has('location_id')"
                          >
                            {{ errors.first('location_id') }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{
                            $t('detailSaleByCustomerReport.customer')
                          }}</label>
                          <a-select
                            v-model="model.customer_id"
                            :options="customers"
                            class="ts-w-full"
                            showSearch
                            mode="multiple"
                            :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                            :placeholder="$t('all')"
                          >
                          </a-select>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{
                            $t('detailSaleByCustomerReport.sale')
                          }}</label>
                          <a-select
                            v-model="model.employee_id"
                            :options="sales"
                            class="ts-w-full"
                            showSearch
                            mode="multiple"
                            :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                            :placeholder="$t('all')"
                          >
                          </a-select>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{
                            $t('detailSaleByCustomerReport.cashier')
                          }}</label>
                          <a-select
                            v-model="model.cashier_id"
                            :options="cashiers"
                            class="ts-w-full"
                            showSearch
                            mode="multiple"
                            :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                            :placeholder="$t('all')"
                          >
                          </a-select>
                        </div>
                      </div>
                    </div>
                    <div>
                      <ts-checkbox
                        v-model="model.amount_due_not_zero"
                        class="ts-mb-4"
                      >
                        {{ $t('detailSaleByCustomerReport.byAmountDue') }}
                      </ts-checkbox>
                    </div>
                    <div>
                      <ts-checkbox
                        v-model="model.has_next_payment_date"
                        class="ts-mb-4"
                      >
                        {{
                          $t('detailSaleByCustomerReport.hasNextPaymentDate')
                        }}
                      </ts-checkbox>
                    </div>
                    <div>
                      <ts-checkbox v-model="model.is_deleted" class="ts-mb-4">
                        {{ $t('detailSaleByCustomerReport.trashed') }}
                      </ts-checkbox>
                    </div>

                    <div class="row">
                      <div class="col-md-6 ts-text-right">
                        <ts-button
                          outline
                          color="success"
                          class="btn-block"
                          @click.prevent="exportExcel"
                          :waiting="exporting"
                          ><i class="far fa-file-excel"></i>
                          {{ $t('export') }}</ts-button
                        >
                      </div>
                      <div class="col-md-6 ts-text-right">
                        <ts-button
                          color="danger"
                          outline
                          class="btn-block"
                          @click.prevent="preview"
                          :waiting="waiting"
                          ><i class="far fa-file-pdf"></i>
                          {{ $t('preview') }}</ts-button
                        >
                      </div>
                    </div>
                  </fieldset>
                </form>
              </ts-loading-banner>
            </ts-card-wrapper>
          </ts-card>
        </div>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('detailSaleByCustomerReport.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { mapActions } from 'vuex'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'

export default {
  name: 'detailSaleByCustomer',
  data() {
    return {
      exporting: false,
      waiting: false,
      loading: false,
      location_loading: false,
      errors: new Errors(),
      branches: [],
      locations: [],
      customers: [],
      cashiers: [],
      sales: [],
      src: '',
      rangeDate: [moment(), moment()],
      model: {
        branch_id: [],
        location_id: [],
        customer_id: [],
        cashier_id: [],
        employee_id: [],
        amount_due_not_zero: false,
        is_deleted: false,
        has_next_payment_date: false
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  },
  methods: {
    ...mapActions('report/resource', [
      'getBranch',
      'getLocation',
      'getCustomer',
      'getCashier',
      'getEmployee'
    ]),
    moment,
    async fetchData() {
      this.loading = true
      await this.getCustomer().then(response => {
        this.customers = response.data.map(el => ({
          value: el.customer_id,
          label: el.customer_name
        }))
      })
      await this.getBranch()
        .then(response => {
          this.branches = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
          this.getLocations()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })

      await this.getEmployee()
        .then(response => {
          this.sales = response.data.map(el => ({
            value: el.employee_id,
            label: el.employee_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })

      await this.getCashier()
        .then(response => {
          this.cashiers = response.data.map(el => ({
            value: el.user_id,
            label: el.name
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async getLocations() {
      this.location_loading = true
      this.model.location_id = []
      this.locations = []
      await this.getLocation({
        branch_id: this.model.branch_id
      })
        .then(response => {
          this.locations = response.data.map(el => ({
            value: el.location_id,
            label: el.location_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.location_loading = false
        })
    },

    preview() {
      this.errors = new Errors()
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('report/sale/detailSaleByCustomer', this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    exportExcel() {
      this.exporting = true
      this.errors = new Errors()
      this.$store
        .dispatch('report/sale/detailSaleByCustomerExcel', this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    },
    dateRangeChange(rangeDate) {
      this.$store.commit(
        'report/sale/SET_DATE_FROM',
        rangeDate[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'report/sale/SET_DATE_TO',
        rangeDate[1].format('DD-MM-YYYY')
      )
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit(
      'report/sale/SET_DATE_FROM',
      moment().format('DD-MM-YYYY')
    )
    this.$store.commit('report/sale/SET_DATE_TO', moment().format('DD-MM-YYYY'))
    next()
  }
}
</script>
